export const isScrolledIntoView = element => {
    if (element) {
            var rect = element.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // only completely visible elements return true
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // for partially visible elements to return true use this:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
    }

    return false;

}